import Vue from 'vue'
import VueI18n from 'vue-i18n'
import App from '@/App'
import router from '@/router'
import store from '@/store'
import { initializeI18n } from '@/i18n'
import UrlUtils from '@/utils/UrlUtils'
import VueSweetalert2 from 'vue-sweetalert2';
import VueGtm from 'vue-gtm'
import Meta from 'vue-meta'
import userUtils from '@/utils/UserUtils'
import VueSanitize from 'vue-sanitize'
import vSelect from 'vue-select'

// Firebase App (the core Firebase SDK) is always required and must be listed first
import * as firebase from "firebase/app"
// Add the Firebase products that you want to use
import "firebase/auth";
import "firebase/database";


// TODO: Replace the following with your app's Firebase project configuration
const firebaseConfig = {
    apiKey: process.env.API_KEY,
    authDomain: process.env.AUTH_DOMAIN,
    databaseURL: process.env.DATABASE_URL,
    projectId: process.env.PROJECT_ID,
    messagingSenderId: process.env.MESSAGING_SENDER_ID,
    appId: process.env.APP_ID
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig)
Vue.component('v-select', vSelect)
Vue.use(VueSweetalert2)
Vue.use(VueI18n)
Vue.use(Meta)
Vue.use(VueSanitize)
Vue.config.productionTip = true


window.$ = window.jQuery = require('jquery')
Vue.use(VueGtm, {
    id: 'GTM-5Z4HTG',
    enabled: true,
    debug: false,
    vueRouter: router,
    ignoredViews: ['accountremoved']
})

let lang = (UrlUtils.getLangaugeName()) ? UrlUtils.getLangaugeName() : ''

try {
    store.dispatch('initializeUser')
        .then((res) => {
            store.state.languageName = lang
            if (store.state.user.languageName) {
                store.state.languageName = store.state.user.languageName
            }

            let i18n = initializeI18n(store.state.languageName)
            firebase.auth().languageCode = userUtils.uniStyleLang(store.state.languageName);
            initializeApp(i18n)
        })
        .catch((_err) => {
            store.state.languageName = lang
            let i18n = initializeI18n(store.state.languageName)
            firebase.auth().languageCode = userUtils.uniStyleLang(store.state.languageName);
            initializeApp(i18n)
        })
} catch (error) {
    store.state.languageName = lang
    let i18n = initializeI18n(store.state.languageName)
    firebase.auth().languageCode = userUtils.uniStyleLang(store.state.languageName);
    initializeApp(i18n)
}

function initializeApp(i18n) {
    return new Vue({
        el: '#app',
        store,
        router,
        i18n,
        template: '<App/>',
        components: { App }
    })
}



// WEBPACK FOOTER //
// ./src/main.js